<template>
  <section id="wms" class="flex-section d-flex flex-column center">
    <div class="section-wrapper d-flex flex-column">
      <p class="header-2 bold color-white">What Makes Us Special</p>
      <div class="section-body color-white">
        <div class="section-content mg-150">
          <p class="header-3">
            Data-Driven Consulting
            <br />with your own Insights.
          </p>
        </div>
        <div class="section-content mg-150 d-flex flex-column">
          <p class="text-1">
            데이터몬스터즈가 전문성을 찾을 수 있도록 도구를 빌려 드립니다.
          </p>
          <p class="text-2 opaque">
            로봇이 기사도 생성하고, 인공지능이 그림을 그릴 수도 있는 4차산업혁명
            시대에
            <br />빅데이터란 대부분의 기술을 이루는 도구이자 토대입니다.
          </p>
          <p class="text-2 opaque">
            우리는 모두 어떤 분야의 전문가입니다.
            <br />제조업에서 IT까지, 인문학에서 공학까지 어떤 산업과 학문이든
            <br />여러분이 쌓아온 전문성과 데이터가 만난다면 <br />지금까지
            발견하지 못했던 문제를 확인하고 대안을 제시할 수 있습니다.
          </p>
          <p class="text-2 opaque">
            주식회사 데이터몬스터즈는
            <br />IoT 스트림 데이터 처리, 자연어 처리, 인공지능 기반 모델링,
            상호작용형 시각화와 같이 <br />여러 영역의 지식을 아우를 수 있는
            기술이 있는 회사입니다.
          </p>
          <p class="text-2 opaque">
            2015년, KAIST 석박사 출신의 연구원들이 창업하여
            <br />독자적인 노하우와 자동화된 솔루션 이상의 통찰력을 가지고
            <br />맞춤형 원스톱 컨설팅을 제공합니다.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
.section-body {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.section-content {
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.mg-150 {
  margin-top: 150px;
}
</style>
